const cmsEndpoints = {
    getUserDetails : () => "/appointment/getalluser",
    addUserDetails : () => "/appointment/createuser",
    editUserDetails : () => "/appointment/edituser",
    loginUser : () => "/appointment/login",
    holidaysList: () => "/appointment/getholidaylist",
    addHoliday: () => "/appointment/addholiday",
    toggleHoliday: () => "/appointment/toggleholiday",
    branchZipcode:(branchID,isActive) => `/appointment/getpostalcodebybranch?branchid=${branchID}&isactive=${isActive}`,
    getPostalCodeByBranch: () => "/appointment/getpostalcodebybranch?branchid=",
    getBranchesList: () => "/appointment/getBranches",
    getBranchDashBoardData: () => "/appointment/getBranchDashBoardData",
    branchAppointmentData: () => "/appointment/schedule",
    saveAppointments : () => `/appointment/SaveAppointments`,
    branchDashBoardData: () => "/Adminappointment/getBranchDashBoardData",
    apptDashboardData: (branchID) => `/appointment/appointmentdashboarddata?branchID=${branchID}`,
    postalCodebyBranch: (branchID) => `/appointment/getpostalcodebybranch?branchid=${branchID}&isActive=`,
    updatePostalCodeByBranch: () => "/appointment/updatepostalcodebybranch",
    updateBranchStatus: () => "/appointment/editBranch",
    getTimeBlockBasedonBranch: () => `/appointment/gettimeblockbasedonbranch?branchid=`,
    updatemaxtimeblock: () => "/appointment/updatemaxtimeblock",
    savetimeblockbasedonbranch: () => "/appointment/savetimeblockbasedonbranch",
}

export default cmsEndpoints;
